// Actions
export const PROCESS_HARDCODED_FORM_DATA = "PROCESS_HARDCODED_FORM_DATA";
export const FORM_FIELD_CHANGE = "FORM_FIELD_CHANGE";
